import * as React from "react"
import { Profiler as BaseProfiler, ProfilerOnRenderCallback } from "react"

const onRender: (phases: Array<string>) => ProfilerOnRenderCallback = (phases) => (id, phase, actualDuration, baseDuration, startTime, commitTime, interations) => {
  if (phases.includes(phase)) console.log("Profiler", { id, phase, actualDuration, baseDuration, startTime, commitTime, interations })
}

export function withProfiler(WrappedComponent: any, phases: Array<any> = ["mount", "update"], id?: string) {
  function Profiler(props: any) {
    return <BaseProfiler id={id || WrappedComponent.displayName || WrappedComponent.name} onRender={onRender(phases)}>
      <WrappedComponent {...props} />
    </BaseProfiler>
  }

  return Profiler
}
